import { connectCheckoutField } from './connectCheckoutField';

export const connectPaymentField = (options: $TSFixMe) =>
    connectCheckoutField({ ...options, valueKey: 'defaultValue' });
